import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const governmentValidationState = atom<boolean>({
  key: 'governmentState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
